export { addButtonDataAttributes, getDefaultConfig } from './config'
